import { PositionPerformanceInfo } from '@tradingblock/types';
import { PositionPerformanceWithPnL } from '../data/global/state';
import { isIndexSymbol } from '@tradingblock/api';

export function changeCalculation(
  last: number,
  close: number,
  prevClose: number,
  bid?: number,
  ask?: number,
  symbol?: string,
  isSettlementSet?: boolean
) {
  // When settled: change = close - prevClose. When not settled: change = last - baseline (baseline = prevClose if available, else close).
  const baseline = prevClose != null && prevClose > 0 ? prevClose : close;
  let change = isSettlementSet ? close - prevClose : last - baseline;
  if (
    !isSettlementSet &&
    !isIndexSymbol(symbol ? symbol : '') &&
    bid !== undefined &&
    ask !== undefined &&
    bid > 0 &&
    ask > 0
  ) {
    if (last < bid) {
      change = bid - baseline;
    } else if (last > ask) {
      change = ask - baseline;
    }
  }
  if (isSettlementSet) {
    return {
      change: change,
      changePercent: prevClose > 0 ? change / prevClose : 0,
    };
  }
  const changeDenom = baseline > 0 ? baseline : close;
  return {
    change: change,
    changePercent: changeDenom > 0 ? change / changeDenom : 0,
  };
}

export const positionToInfo = (p: PositionPerformanceWithPnL): PositionPerformanceInfo => {
  //Formula only MktBid and MktAsk > 0:
  //Last < MktBid ? MktChange = MktBid : Last > MktAsk ? MktChange = MktAsk : MktChange = Last - Close (server closed data).
  const { change, changePercent } = changeCalculation(
    p.lastTradePrice,
    p.close,
    p.prevClose,
    p.bid,
    p.ask,
    p.underlyingSymbol,
    p.IsSettlementSet
  );

  const changeValue = p.change || change;
  const gainValue = p.gain;
  const dayGainValue = p.useCalculatedPnL ? p.dailyPnl : p.pnl;

  return {
    pnl: p.pnl,
    ask: p.ask,
    bid: p.bid,
    lastTradePrice: p.lastTradePrice,
    bestTradePrice: p.bestTradePrice,
    cost: p.cost,
    change: changeValue,
    changePerc: p.changePercent || changePercent * 100,
    calculatedChange: change,
    calculatedChangePercent: changePercent * 100,
    quantity: p.shares || 0,
    optionsCount: p.options || 0,
    sharesSum: p.sharesSum,
    dayGain: dayGainValue,
    totalGain: gainValue,
    value: p.value,
    symbol: p.symbol,
    underlyingSymbol: p.underlyingSymbol,
    close: p.close,
    description: p.description,
    IsSettlementSet: p.IsSettlementSet,
    prevClose: p.prevClose,
    commission: p.commission,
    dailyPnl: p.dailyPnl,
    overallPnl: p.overallPnl,
    useCalculatedPnL: p.useCalculatedPnL,
  };
};
